var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.625 7.87501C17.7187 7.87501 17.8046 7.91407 17.8828 7.9922C17.9609 8.07032 18 8.15626 18 8.25001V9.75001C18 9.84376 17.9609 9.92969 17.8828 10.0078C17.8046 10.0859 17.7187 10.125 17.625 10.125H10.125V17.625C10.125 17.7187 10.0859 17.8047 10.0078 17.8828C9.92966 17.9609 9.84373 18 9.74998 18H8.24998C8.15623 18 8.07029 17.9609 7.99217 17.8828C7.91404 17.8047 7.87498 17.7187 7.87498 17.625V10.125H0.374999C0.281249 10.125 0.195312 10.0859 0.117187 10.0078C0.0390622 9.92969 0 9.84376 0 9.75001V8.25001C0 8.15626 0.0390622 8.07032 0.117187 7.9922C0.195312 7.91407 0.281249 7.87501 0.374999 7.87501H7.87498V0.37503C7.87498 0.28128 7.91404 0.195343 7.99217 0.117218C8.07029 0.0390927 8.15623 3.05176e-05 8.24998 3.05176e-05H9.74998C9.84373 3.05176e-05 9.92966 0.0390927 10.0078 0.117218C10.0859 0.195343 10.125 0.28128 10.125 0.37503V7.87501H17.625Z",
    fill: "#008187"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGreen);
export default __webpack_public_path__ + "static/media/plus-green.26f4facdb443c5a81d08f6a1c1712fe2.svg";
export { ForwardRef as ReactComponent };